import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'WalletRechargeEdit',
  data: function data() {
    return {
      title: '',
      form: {
        walletId: null,
        leve: null,
        price: null,
        currency: null
      },
      rules: {
        walletId: [{
          required: true,
          message: '请输入主键',
          trigger: 'blur'
        }],
        leve: [{
          required: true,
          message: '请输入充值档位',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入人民币充值金额',
          trigger: 'blur'
        }],
        currency: [{
          required: true,
          message: '请输入购买媒币数量',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.walletId = null;
      this.form.leve = null;
      this.form.price = null;
      this.form.currency = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.walletId = data.walletId + '';
      this.form.leve = data.leve + '';
      this.form.price = data.price + '';
      this.form.currency = data.currency + '';
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_WALLETRECHARGE(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_WALLETRECHARGE(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.walletId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};